export const MODAL_TYPES = {
  ECCN_DETAIL: 'ECCN_DETAIL',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  MESSAGE: 'MESSAGE',
  RFQ: 'RFQ',
  OFFER_VENDOR_DETAIL: 'OFFER_VENDOR_DETAIL',
  OFFER_MANUAL_UPLOAD_VENDOR_QUOTATION: 'OFFER_MANUAL_UPLOAD_VENDOR_QUOTATION',
  OFFER_COST_BUDGET_QUOTATION_DETAIL: 'OFFER_COST_BUDGET_QUOTATION_DETAIL',
  DRAFT_PR_SUBMISSION: 'DRAFT_PR_SUBMISSION',
  INVITATION_DETAIL: 'INVITATION_DETAIL',
  PR_INVITATION_DETAIL: 'INVITATION_DETAIL',
  ADD_INVITATION: 'ADD_INVITATION',
  REPLY_INVITATION: 'REPLY_INVITATION',
  // add more...
}
